'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.generateId = void 0;
/*
    Tiny MongoDB ObjectId implementation.
    ObjectId is 12-byte, constructed using:
    a 4-byte value representing the seconds since the Unix epoch,
    a 3-byte machine identifier,
    a 2-byte process id, and
    a 3-byte counter, starting with a random value.
    For more information see:
    http://docs.mongodb.org/manual/reference/object-id
*/
function generateId() {
    var mid = Math.trunc(Math.random() * 0xffffff);
    // 2-byte process id
    var pid = Math.trunc(Math.random() * 0xffff);
    // 3-byte counter, starting with a random value
    var cnt = Math.trunc(Math.random() * 0xffffff);
    // helper function to format hex numbers with padding
    var hex = function (num, size) {
        return ('00000000' + num.toString(16)).substr(-size);
    };
    // 4-byte value representing the seconds since the unix epoch
    var sec = Math.trunc(Date.now() / 1000);
    // reset or increment the counter
    if (cnt > 0xffffff) {
        cnt = Math.trunc(Math.random() * 0xffffff);
    }
    else {
        cnt++;
    }
    // returns the newly generated object id as a formatted hex string
    return hex(sec, 8) + hex(mid, 6) + hex(pid, 4) + hex(cnt, 6);
}
exports.generateId = generateId;
